import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function initGsapSticker() {
    function gsapSticker(track, item = null) {
        if (!item) {
            item = track.querySelector("[sticky-item]");
        }
        if (!item) return;

        const startOffset = item.offsetTop - track.offsetTop;
        const stickyPos = item.getAttribute("sticky-item");
        
        let start, end;

        if (stickyPos === "bottom") {
            const bottomOffset = 0;
            start = `top+=${startOffset + item.offsetHeight} bottom-=${bottomOffset}`;
            end = `bottom bottom-=${bottomOffset}`;
        } else {
            const headerOffset = APP_HEADER_HEIGHT * 1.5;
            start = `top+=${startOffset} top+=${headerOffset}`;
            end = `bottom top+=${headerOffset + item.offsetHeight}`;
        }

        ScrollTrigger.create({
            markers: false,

            pin: item,
            pinSpacing: false,

            trigger: track,
            start: () => {
                const headerOffset = (window.APP_HEADER_HEIGHT || 0) * 1.5;
                return stickyPos === "bottom" 
                    ? `top+=${startOffset + item.offsetHeight} bottom`
                    : `top+=${startOffset} top+=${headerOffset}`;
            },
            end: () => {
                const headerOffset = (window.APP_HEADER_HEIGHT || 0) * 1.5;
                return stickyPos === "bottom"
                    ? `bottom bottom`
                    : `bottom top+=${headerOffset + item.offsetHeight}`;
            },
    

            toggleClass: { targets: item, className: "is-stuck" },
        });
    }
    
    // Standard usage
    gsap.utils.toArray("[sticky-track]").forEach(track => gsapSticker(track));
}
